<template>
  <!-- footer start -->
   <footer>
      <!-- footer here -->
      <div style="height:50px"></div>
   </footer>
   <!-- footer End -->
</template>

<script>
   export default {
    name: 'Footer',

    mixins: [],

    components:
    {
      
    },

    data: () => ({
      
    }),

    computed:
    {
      
    },

    methods:
    {
      
    },

    load(){}
  }
</script>